import React, {useContext} from "react";
import {RouteContext} from "./context";


function withAuth<T>(permission: string, CC: React.ComponentType<T> | React.ExoticComponent<any>) {
    return function (props: T) {
        const context = useContext(RouteContext)
        if (context?.resources.indexOf(permission) !== -1) {
            if (typeof (CC) === 'symbol') {
                // @ts-ignore
                return <React.Fragment {...props} />
            } else {
                // @ts-ignore
                return <CC {...props} />
            }
        } else {
            return null
        }
    }
}

export default withAuth
